import { createStoreContext as o } from "./LMDWO4NN.js";
var e = o(), r = e.useContext;
e.useScopedContext;
e.useProviderContext;
var n = e.ContextProvider, C = e.ScopedContextProvider;
export {
  n as CollectionContextProvider,
  C as CollectionScopedContextProvider,
  r as useCollectionContext
};
//# sourceMappingURL=VDHZ5F7K.js.map
